<template>
    <Datepicker
        v-model="modelValue"
        :dusk="dusk"
        :tabindex="tabindex"
        :class="[`forms__field_input--${field?.type ?? 'date'}`]"
        :nullable="typeof field?.nullable !== 'undefined' ? field.nullable : props.nullable"
        :required="field?.required ? parseInt(field.required) === 1 : props.required"
        :size="props.size"
        :disabled="props.disabled"
    ></Datepicker>
</template>

<script setup lang="ts">
import type { FieldComponent } from '@src/Common/Components/types';

const modelValue = defineModel({
    type: String,
});

const props = withDefaults(defineProps<FieldComponent>(), {});
</script>
